import React, { useEffect, useState } from "react";
import { useAuth } from "../../../AuthContext";
import DefaultProfileImage from "../../../Images/default-profile.webp";
import "./UserProfile.css";
import { fetchTeacherById } from "../../ApiController/teacherApi";

const UserProfile = () => {
	const auth = useAuth();
	const [teacherInfo, setTeacherInfo] = useState(null);
	const [userImage, setUserImage] = useState(null);

	useEffect(() => {
		const fetchTeacherInfo = async () => {
			try {
				const userId = sessionStorage.getItem("userId");
				const teacherData = await fetchTeacherById(userId);
				setTeacherInfo(teacherData);
				setUserImage(teacherData.imgdata);
			} catch (error) {
				console.error("Error fetching teacher information:", error);
			}
		};

		if (auth.isLoggedIn) {
			fetchTeacherInfo();
		}
	}, [auth.isLoggedIn, auth.user]);

	return (
		<div className="container p-0">
			{auth.isLoggedIn && (
				<div className="d-flex align-items-end ">
					<div className="">
						<img
							src={userImage || DefaultProfileImage}
							alt="Profile"
							className="img-thumbnail profile-image"
						/>
						{teacherInfo && (
							<div className="teacher-name">
								{teacherInfo.firstName} {teacherInfo.lastName}
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default UserProfile;
